<template>
    <v-app>
        <v-container>
            <v-row>
                <h4 style="color:#1C2546;margin-top:45px">Agregar Usuario</h4>
            </v-row>
            <v-row>      
                <v-alert type="success" class="justify-content-center col-lg-12 text-center" :value='alertSucess' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
                <v-alert type="error" class="justify-content-center col-lg-12 text-center" :value='alertError' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
            </v-row>
            <v-row class="mt-5">
                <v-col lg="12">
                    <v-text-field
                        name="username"
                        label="Correo"
                        id="username"
                        v-model="user.username"
                        :error="isUnAuth"
                        @change="isUnAuth=false;alertError=false"
                    >                   
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col lg="12">
                    <v-text-field
                        name="pass"
                        label="Contraseña"
                        id="pass"
                        v-model="user.pass"
                        :type="(!see_pass?'password':'text')"
                        :error="isUnAuth"
                        @change="isUnAuth=false;alertError=false"
                    >
                    <div slot="append">
                        <v-icon class="pointer" @click="click" v-if="!see_pass">mdi-eye</v-icon>
                        <v-icon class="pointer" @click="click" v-else>mdi-eye-off</v-icon>
                        
                    </div>
                    </v-text-field>
                </v-col>   

            </v-row>
            <v-row>
                <v-col lg="12">
                    <v-text-field
                        name="pass"
                        label="Repita contraseña"
                        id="repass"
                        v-model="user.repass"
                        :type="(!see_repass?'password':'text')"
                        :error="isUnAuth"
                        @change="isUnAuth=false;alertError=false"
                    >
                    <div slot="append">
                        <v-icon class="pointer" @click="clickRe" v-if="!see_repass">mdi-eye</v-icon>
                        <v-icon class="pointer" @click="clickRe" v-else>mdi-eye-off</v-icon> 
                    </div>
                    </v-text-field>
                </v-col>                                                
            </v-row>
            <v-row>
                <v-col lg="12">
                    <v-select
                        v-model="user.id_empleado"
                        :items="empleados"
                        item-value="id"
                        label="Empleado"
                        required
                        :error="isUnAuth"
                        @change="isUnAuth=false;alertError=false"
                        @blur="$v.select.$touch()"
                    >
                        <template slot="selection" slot-scope="data">
                            <!-- HTML that describe how select should render selected items -->
                            {{ data.item.nombre }} ({{ data.item.puesto }})
                        </template>
                        <template slot="item" slot-scope="data">
                            <!-- HTML that describe how select should render items when the select is open -->
                            {{ data.item.nombre }} ({{ data.item.puesto }})
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex"  cols="12" sm="12">
                    <v-btn color="success" class="mr-4" @click="saveUser">Guardar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import axios from 'axios'
import { v4 as uuidv4 } from "uuid";
import router from '../../router/index.js'

export default {
    data(){
        return {
            message: '',
            alertSucess: false,
            alertError: false,
            see_pass: false,
            see_repass: false,
            isUnAuth: false,
            user: {
                id: uuidv4(),
                username: '',
                pass: '',
                repass: '',
                id_empleado: ''
            },
            empleados: [],
        }
    },
    methods:{
        getEmpleados: async function(){
            axios.get('https://'+process.env.VUE_APP_URL+':3000/select/empleados/usuarios')
            .then((response) => {
                //console.log(response);
                this.empleados = response.data;
            })
        },
        saveUser: async function(){
            if (!this.validEmail(this.user.username)) {
                this.message = 'Formato de correo inválido';
                this.isUnAuth = true;
                this.alertError = true;
                this.alertSucess = false;
            } else if(this.user.pass == '') {
                this.message = 'La contraseña no puede ir vacia';
                this.isUnAuth = true;
                this.alertError = true;
                this.alertSucess = false;
            } else if(this.user.repass == ''){
                this.message = 'Repetir contraseña no puede ir vacio';
                this.isUnAuth = true;
                this.alertError = true;
                this.alertSucess = false;
            } else if (this.user.id_empleado == '') {
                this.message = 'Por favor selecciones a un empleado';
                this.isUnAuth = true;
                this.alertError = true;
                this.alertSucess = false;
            } else {
                axios.post('https://'+process.env.VUE_APP_URL+':3000/usuarios/',this.user)
                .then((response) => {
                    if(response.data.message == "Guardado"){
                         this.message = 'Usuario creado exitosamente';
                         this.alertError = false;
                         this.alertSucess = true;
                    }else{
                        this.message = response.data.message;
                        this.isUnAuth = true;
                        this.alertError = true;
                        this.alertSucess = false;
                    }
                })
            }
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        click: function(){
            this.see_pass=!this.see_pass
        },
        clickRe: function(){
            this.see_repass=!this.see_repass
        }

    },
    mounted() {
        //Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;

        axios.interceptors.response.use(function (response){
            //console.log(response.data.message);
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        //End config for axios

        this.getEmpleados();
    }
   
}
</script>

<style>
    .pointer{
        cursor: pointer;
    }
</style>